import { render, staticRenderFns } from "./NikudOptionsPane.vue?vue&type=template&id=360b3498&scoped=true&"
import script from "./NikudOptionsPane.vue?vue&type=script&lang=js&"
export * from "./NikudOptionsPane.vue?vue&type=script&lang=js&"
import style0 from "./NikudOptionsPane.vue?vue&type=style&index=0&id=360b3498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b3498",
  null
  
)

export default component.exports